import React from 'react';

import { ConnectComponentsProvider, ConnectPayouts } from '@stripe/react-connect-js';

import { WorkspaceLayout } from '../../../shared/components/Layout';
import { useStripeConnect } from '../../../shared/hooks';

import styles from '../../../shared/styles/_layout.module.scss';

const Payouts = () => {
  const { stripeConnectInstance } = useStripeConnect();

  return (
    <WorkspaceLayout>
      <h1 className={styles.dashboard__title}>Payouts</h1>

      {stripeConnectInstance && (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <ConnectPayouts />
        </ConnectComponentsProvider>
      )}
    </WorkspaceLayout>
  );
};

export default Payouts;
